import React from 'react';
import { LegalPageLayout } from '@/components/shared/LegalPageLayout';

export default function TermsOfServicePage() {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated="January 15, 2025">
      <div className="space-y-8">
        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            By accessing or using Agentick's platform, website, or any related services (collectively, the "Services"), you agree to be bound by these Terms of Service ("Terms"). If you are using the Services on behalf of a business or organization, you represent that you have the authority to bind that entity to these Terms.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">2. Description of Services</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            Agentick provides a WhatsApp AI chatbot platform that enables businesses to create AI-powered chat agents, manage knowledge bases, capture leads, and automate customer interactions on WhatsApp. The platform is built on open-source WhatsApp APIs and does not require the official WhatsApp Business API.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">3. Account Registration</h2>
          <ul className="list-disc list-inside space-y-1.5 text-sm text-muted-foreground font-body ml-2">
            <li>You must provide accurate, current, and complete registration information</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials</li>
            <li>You must be at least 18 years old to use the Services</li>
            <li>One person or business may not maintain more than one free trial account</li>
            <li>You are responsible for all activities that occur under your account</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">4. Free Trial</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            Agentick offers a 7-day free trial with full platform access. No credit card is required. At the end of the trial period, your account will be paused unless you upgrade to a paid plan. Your data will be retained for 30 days after trial expiration, after which it may be permanently deleted.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">5. Payment & Billing</h2>
          <ul className="list-disc list-inside space-y-1.5 text-sm text-muted-foreground font-body ml-2">
            <li>Paid plans are billed monthly in Indian Rupees (INR)</li>
            <li>Payment is due at the beginning of each billing cycle</li>
            <li>All fees are non-refundable unless otherwise stated</li>
            <li>We reserve the right to modify pricing with 30 days advance notice</li>
            <li>Failed payments may result in service suspension after a 7-day grace period</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">6. Acceptable Use</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed mb-3">
            You agree not to use the Services to:
          </p>
          <ul className="list-disc list-inside space-y-1.5 text-sm text-muted-foreground font-body ml-2">
            <li>Send spam, unsolicited messages, or bulk promotional content</li>
            <li>Engage in any illegal, fraudulent, or deceptive activities</li>
            <li>Violate WhatsApp's terms of service or community guidelines</li>
            <li>Collect sensitive personal data (financial, health) without proper consent and safeguards</li>
            <li>Impersonate another person or entity</li>
            <li>Interfere with or disrupt the integrity of the Services</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">7. Intellectual Property</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            All content, features, and functionality of the Services — including software, text, graphics, logos, and trademarks — are owned by Agentick and protected by intellectual property laws. You retain ownership of all content you upload to the platform, including knowledge base documents and business information.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">8. Limitation of Liability</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            To the maximum extent permitted by law, Agentick shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Services. Our total liability shall not exceed the amount you paid to Agentick in the twelve (12) months preceding the claim.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">9. Termination</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            Either party may terminate the agreement at any time. You may cancel your subscription from your account dashboard. We may suspend or terminate your access if you violate these Terms. Upon termination, your right to use the Services ceases immediately, and we may delete your data after a 30-day retention period.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">10. Governing Law</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            These Terms are governed by the laws of India. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Bengaluru, Karnataka, India.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-lg font-semibold text-foreground mb-3">11. Contact</h2>
          <p className="text-sm text-muted-foreground font-body leading-relaxed">
            For questions about these Terms, contact us at <span className="text-primary">legal@agentick.com</span>.
          </p>
        </section>
      </div>
    </LegalPageLayout>
  );
}
